var Backbone = require("../../libs/backbone/backbone");
var GenericModel = require("./generic.model.ts");

var KiosksModel = GenericModel.extend(
{
    urlRoot : '/rest/api/kiosks',
    id : null,
    name : "",
    apiKey: "",
    queues: ""
});

module.exports = KiosksModel;